import { Grid, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useNotify } from 'react-admin'

import Api from '../../../Apis/api.service'

import {
  Truncate,
  ResolutionMajority,
  ResolutionStatus,
  VoteProgress,
  OpenButton,
  ResolutionEdit,
  CreateSubButton,
  CreateSiblingButton,
  DeleteButton,
  OpenParent,
  DeleteVotesAndPutVPCToContre,
  Votes,
  CloseButton,
  OpenNext,
  Alert,
  Passerelle,
} from '.'
import { Accordion, AccordionDetails, AccordionSummary } from '../styles'

import { MakeAllVotesButton } from './MakeAllVotesButton'
import ApiVotes from '../api/apiVotes'

export const ResolutionAccordion = ({
  resolution,
  ag,
  setOpenResolutionId,
  setLastRefreshTime,
  lastRefreshTime,
  openResolutionId,
  setIsChanged,
  isChanged,
  isSomeThingsChange,
  setIsSomeThingsChange,
}) => {
  const apiVotes = new ApiVotes()

  let style = {}
  const [open, setOpen] = useState(false)
  const [showWarningAlert, setShowWarningAlert] = useState(false)
  const notify = useNotify()
  useEffect(() => {
    if (openResolutionId == resolution.id) {
      setOpen(() => {
        return true
      })
    }
  }, [resolution])
  return (
    <Accordion
      defaultExpanded={openResolutionId == resolution.id}
      expanded={open}
      onChange={(event, isExpanded) => {
        event.stopPropagation()
        if (isSomeThingsChange.length) {
          setShowWarningAlert(true)
        }
        setOpenResolutionId((prev) => {
          return resolution.id
        })
        setOpen(isExpanded)
      }}
    >
      {showWarningAlert && (
        <Alert
          open={showWarningAlert}
          setOpen={setShowWarningAlert}
          resolutionsUnsaved={isSomeThingsChange}
        />
      )}

      <AccordionSummary
        aria-controls="panel1d-content"
        id="panel1d-header"
        sx={style}
      >
        <div style={{ marginRight: '1em' }}>
          <ResolutionStatus record={resolution} />
        </div>
        <Typography style={{ marginRight: '1em' }}>
          {resolution.numero}. {Truncate(resolution.libelle)}
        </Typography>
        <ResolutionMajority record={resolution} />

        <div style={{ margin: '0 0 0 auto' }}>
          {/* VoteProgress */}
          {resolution.opened && (
            <VoteProgress
              record={resolution}
              lastRefreshTime={lastRefreshTime}
              openResolutionId={openResolutionId}
              isChanged={isChanged}
            />
          )}
          {/* Open Button */}
          <OpenButton
            record={resolution}
            ag={ag}
            setIsChanged={setIsChanged}
            setOpenResolutionId={setOpenResolutionId}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            {/* RESOLUTION EDIT  */}
            <ResolutionEdit
              lastRefreshTime={lastRefreshTime}
              setLastRefreshTime={setLastRefreshTime}
              setIsSomeThingsChange={setIsSomeThingsChange}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
              record={resolution}
              onSuccess={({ data }) => {
                notify('Résolution enregistrée avec succés')
                setIsChanged((prev) => {
                  let newVal = new Date().getTime()
                  return newVal
                })
                // setOpen(!open)
                // console.log({ data })
                // // This functionality needs a huge refactor because each time that someone
                // // open a resolution update and use the ag "open_resultion_id" instead of the data of the current form
                // Api.ags3
                //   .update(data.ag_id, {
                //     open_resolution_id: data.id,
                //     editing_open_resolution_id: true,
                //     force: true,
                //   })
                //   .then((res) => {
                //     notify('Résolution enregistrée avec succés')
                //     setIsChanged((prev) => {
                //       let newVal = new Date().getTime()
                //       return newVal
                //     })
                //   })
                //   .catch((err) => {
                //     notify(`${err.message}`, 'warning')
                //     setIsChanged((prev) => {
                //       let newVal = new Date().getTime()
                //       return newVal
                //     })
                //   })
              }}
              notify={notify}
            />
          </Grid>
          <Grid
            container
            item
            xs={2}
            spacing={2}
            style={{
              flexWrap: 'unset',
              height: 'fit-content',
              flexDirection: 'column',
            }}
          >
            {/* CreateSubButton */}
            <CreateSubButton
              record={resolution}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
              setOpen={setOpen}
            />
            {/* CreateSiblingButton */}
            <CreateSiblingButton
              record={resolution}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
              setOpen={setOpen}
            />
            {/* Passerelle */}
            <Passerelle
              record={resolution}
              setIsChanged={setIsChanged}
              setOpenResolutionId={setOpenResolutionId}
              onSuccess={(args) => {
                setOpen(!open)
              }}
            />
            <DeleteButton record={resolution} setIsChanged={setIsChanged} />

            {/* OpenParent */}
            <OpenParent
              record={resolution}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
            />
            <Grid item xs={12}>
              <hr />
            </Grid>
            <MakeAllVotesButton
              resolution={resolution}
              setIsChanged={setIsChanged}
              title="Faire voter TLM POUR"
              buildApiPromise={() =>
                Api.resolutions.create({ allpour: true, ...resolution })
              }
            />
            <MakeAllVotesButton
              resolution={resolution}
              setIsChanged={setIsChanged}
              title="Faire voter TLM CONTRE"
              buildApiPromise={() =>
                apiVotes.postAgResolutionVotesAllAgainst(
                  ag.internal_id,
                  resolution.id
                )
              }
            />
            {/* DeleteVotesAndPutVPCToContre */}
            <DeleteVotesAndPutVPCToContre
              record={resolution}
              setIsChanged={setIsChanged}
            />
            {/* Votes */}
            <Votes
              record={resolution}
              label="Gérer les votes"
              ag={ag}
              isResolutionOpen={open && resolution.opened}
              setIsChanged={setIsChanged}
            />
            {/* CloseButton */}
            <CloseButton
              ag={ag}
              resolution={resolution}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
              onSuccess={() => {
                setOpen(!open)
              }}
            />
            {/* OpenNext */}
            <OpenNext
              ag={ag}
              resolution={resolution}
              setOpenResolutionId={setOpenResolutionId}
              setIsChanged={setIsChanged}
              setOpen={setOpen}
              open={open}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}
